<template>
  <section>
    <h3 class="primary--text"><v-icon color="primary">settings</v-icon> {{ $t('parametro.preferencias') }}</h3>
    <v-tabs
      v-model="active"
      class="tab-preferencias"
      color="info"
      dark
      slider-color="warning"
    >
      <v-tab
        key="sistemas"
        href="#sistemas"
        ripple>
        <v-icon>laptop</v-icon> Sistema
      </v-tab>
      <v-tab
        key="roles"
        href="#roles"
        ripple>
        <v-icon>person_outline</v-icon> {{ $t('rol.title') }}
      </v-tab>
      <v-tab
        key="recursos"
        href="#recursos"
        ripple>
        <v-icon>menu</v-icon> Recursos
      </v-tab>
      <v-tab-item
        key="sistemas"
        value="sistemas">
        <v-card flat>
          <sistema v-if="active == 'sistemas'"></sistema>
        </v-card>
      </v-tab-item>
      <v-tab-item
        key="roles"
        value="roles">
        <v-card flat>
          <rol v-if="active == 'roles'"></rol>
        </v-card>
      </v-tab-item>
			<v-tab-item
        key="recursos"
        value="recursos">
        <v-card flat>
          <recurso v-if="active == 'recursos'"></recurso>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </section>
</template>

<script>
import Rol from './components/Rol';
import Parametro from './components/Parametro';
import Recurso from './components/Recurso.vue';
import Sistema from './components/Sistema.vue';

export default {
  data () {
    return {
      active: 'roles'
    };
  },
  mounted () {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [120] // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push('/403')
    }
  },
  components: {
    Rol,
    Parametro,
		Recurso,
    Sistema
  },
  watch: {
    active: function (val) {
      console.log(val);
    }
  }
};
</script>

<style lang="scss">
  .tab-preferencias {
    .v-tabs__wrapper {
      margin: 0 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/rol-recurso/Index.vue